<template>
    <div id="unpack_manage">
        <div class="apart-top flex-row ">
            <div class="flex-row t-p-l-22 cursor_1" @click.stop="toPage">
                <img class="back-img" :src="require('@/assets/image/icon_right.png')">
                <span class="apart-top-title">
                    返回
                </span>
            </div>
            <!-- <el-button @click.stop="toLog" type="warning" size="mini" style="margin-left: 30px;font-size: 16px;" round plain>仿写记录</el-button> -->
            <!-- <el-button class="cursor_1" type="text" style="margin-left: 30px;font-size: 16px;">仿写记录</el-button> -->
        </div>
        <main class="unpack_main">
            <Left ref="left" :id="id" @getDetail="getDetail"></Left>
            <Center ref="center" :id="id" :detailData="detailData"></Center>
            <Right ref="right" :id="id" :detailData="detailData" :result="detailData.result"></Right>
        </main>
        <popup ref="delPopup" @confirm="confirm"></popup>
    </div>
</template>
<script>
import apart from '@/api/apart';
import Left from '@/components/novelTurnScript/manage/left.vue';
import Center from '@/components/novelTurnScript/manage/center.vue';
import Right from '@/components/novelTurnScript/manage/right.vue';
import popup from '@/components/dongeb/popup.vue';
import loadingStatus from '@/components/loading_status.vue' //加载效果
export default {
    components: {
        Left, Center, Right, popup
    },
    data() {
        return {
            id: '',
            detailData: {},
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                type: 0
            }
        }
    },
    created() {
        sessionStorage.removeItem('apartStatus')
        let { id,title } = this.$route.query
        if (!id) {
            this.id = ''
            this.$message.error('未有转剧本主要参数')
            setTimeout(() => {
                this.$router.push('/novelTurnScript_list')
            }, 200);
        } else {
            this.id = id
            sessionStorage.setItem('title', title)
            // apart.apartDetail({ id: this.id }).then(res => {
            //     if (res.code === 200) {
            //         sessionStorage.setItem('title', res.data.title)
            //     }
            // })
        }

    },
    methods: {
        toPage() {
            let apartStatus = JSON.parse(sessionStorage.getItem('apartStatus'))
            if (apartStatus) {
                if (apartStatus.status !== 'ok') {
                    this.$refs.delPopup.openPrompt(11);
                    return;
                }
            }
            //通配符移除
            Object.keys(sessionStorage).forEach(key => {
                if (key.includes('_csText')) {
                    sessionStorage.removeItem(key);
                }
                if (key.includes('_fxText')) {
                    sessionStorage.removeItem(key);
                }
            });
            sessionStorage.removeItem('apartStatus')
            this.$router.replace('/novelTurnScript_list');
        },
        confirm() {
            let apartStatus = JSON.parse(sessionStorage.getItem('apartStatus'))
            if (apartStatus) {
                sessionStorage.removeItem(apartStatus.id + '_csText')
                sessionStorage.removeItem(apartStatus.id + '_fxText')
                sessionStorage.removeItem('apartStatus')
            }
            this.$router.replace('/novelTurnScript_list');

        },
        getDetail(e) {
            if (!e.id) {
                throw Error('章节id未获取成功');
            }
            console.log('获取详细信息=', e)
            this.detailData = e
            this.$refs.right.tabs(e.result)
        },
        refreshList(id) {
            this.$refs.left.refreshList(id);
        },
        // toLog(){
        //     this.$router.push({path:'/apart_log',query:{apartId:this.id}});
        // }
    }
}
</script>
<style lang="scss" scoped>
#unpack_manage {
    height: 100vh;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    .apart-top {
        width: 100%;
        height: 64px;
        background: #FFFFFF;
        box-shadow: 0px 1px 8px 0px rgba(117, 53, 0, 0.12);
        border-radius: 0px 0px 0px 0px;

        .back-img {
            display: block;
            margin-top: 2px;
        }

        .apart-top-title {
            height: 16px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
            line-height: 16px;
            margin-left: 4px;
        }
    }

    .unpack_main {
        width: 100%;
        flex: 1;
        display: flex;
        box-sizing: border-box;
        position: relative;
        overflow: hidden;
        padding-top: 12px;
    }
}
</style>